import * as psl from 'psl';
import { ParsedDomain } from 'psl';
import CookieStore, { CookieAttributes } from 'js-cookie';

export const Cookies = {
  AuthToken: `AUTH_TOKEN_${import.meta.env.MODE}`,
};

export default function useAppCookies() {
  return {
    getCookie: (key: string) => CookieStore.get(key),
    setCookie: (key: string, value: string, options: CookieAttributes) =>
      CookieStore.set(key, value, {
        domain: (psl.parse(window.location.hostname) as ParsedDomain).domain ?? 'localhost',
        path: '/',
        ...options,
      }),
    removeCookie: (key: string) =>
      CookieStore.remove(key, {
        domain: (psl.parse(window.location.hostname) as ParsedDomain).domain ?? 'localhost',
        path: '/',
      }),
  };
}
